// Sport-specific coaching and support staff roles
export const SPORT_COACH_ROLES: { [key: string]: string[] } = {
  'Basketball': [
    'head_coach',
    'assistant_coach', 
    'associate_head_coach',
    'offensive_coordinator',
    'defensive_coordinator',
    'player_development_coach',
    'strength_conditioning_coach',
    'skills_coach',
    'recruiting_coordinator',
    'volunteer_assistant'
  ],
  'Football': [
    'head_coach',
    'offensive_coordinator',
    'defensive_coordinator',
    'special_teams_coordinator',
    'quarterbacks_coach',
    'running_backs_coach',
    'wide_receivers_coach',
    'offensive_line_coach',
    'defensive_line_coach',
    'linebackers_coach',
    'defensive_backs_coach'
  ],
  'Soccer': [
    'head_coach',
    'assistant_coach',
    'goalkeeping_coach',
    'fitness_coach',
    'tactical_coach',
    'youth_coach',
    'volunteer_coach'
  ],
  // Add more sports as needed
};

export const SPORT_SUPPORT_ROLES: { [key: string]: string[] } = {
  'Basketball': [
    'athletic_trainer',
    'team_doctor',
    'scout',
    'video_coordinator',
    'equipment_manager',
    'team_manager',
    'statistician',
    'sports_psychologist',
    'nutritionist',
    'fan_coordinator'
  ],
  'Football': [
    'athletic_trainer',
    'team_doctor',
    'scout',
    'video_coordinator',
    'equipment_manager',
    'team_manager',
    'statistician',
    'sports_psychologist',
    'nutritionist',
    'strength_conditioning_assistant'
  ],
  'Soccer': [
    'athletic_trainer',
    'team_doctor',
    'scout',
    'video_coordinator',
    'equipment_manager',
    'team_manager',
    'statistician',
    'sports_psychologist',
    'nutritionist',
    'fan_coordinator'
  ],
  // Add more sports as needed
};

export const getCoachRolesForSport = (sport: string): string[] => {
  return SPORT_COACH_ROLES[sport] || [
    'head_coach',
    'assistant_coach',
    'volunteer_coach'
  ];
};

export const getSupportRolesForSport = (sport: string): string[] => {
  return SPORT_SUPPORT_ROLES[sport] || [
    'team_manager',
    'equipment_manager',
    'scout'
  ];
};

export const formatRoleName = (role: string): string => {
  return role.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
};